import {ApiClient} from '@hconnect/apiclient'
import {useQueries} from '@tanstack/react-query'

export const ANOMALY_MEDIA_QUERY_KEY = 'anomaly-event-media'

export type AnomalyMediaItem = {
  dataCaptureUuid: string
  fileName: string
  mediaData: string
}

type AnomalyEventMediaResponse = {
  anomalyDto: string
  mediaItems: AnomalyMediaItem[]
}

export const useAnomalyEventMedia = (plantId: string, anomalyIds: string[]) => {
  const results = useQueries({
    queries: anomalyIds.map((anomalyId) => ({
      queryKey: [ANOMALY_MEDIA_QUERY_KEY, plantId, anomalyId],
      queryFn: async (): Promise<AnomalyEventMediaResponse> => {
        const response = await ApiClient.axiosInstance.get<AnomalyEventMediaResponse>(
          `/spot-integration/Anomaly/${plantId}/anomaly-event-media/${anomalyId}`
        )
        return response.data
      },
      enabled: !!plantId && !!anomalyId
    }))
  })

  const isLoading = results.some((r) => r.isLoading)
  const hasError = results.some((r) => r.isError)
  const mediaItems = results.flatMap((r): AnomalyMediaItem[] => r.data?.mediaItems ?? [])

  return {isLoading, hasError, mediaItems, results}
}
